import { MaintenanceInterceptor } from '../app/shared/interceptors/maintenance.interceptor';

/**
 * Global environment properties when running app in production.
 */
export const environment = {
	production: true,
	useGatewayInterceptor: false
};

/**
 * Interceptors to initialize with the app in production.
 */
export const INTERCEPTORS = [MaintenanceInterceptor];
